<template>
  <div class="col-md-12 mail-container pt-20 pb-20 mb-10">
    <div class="row">
      <button
        v-if="showEdit"
        id="set-edit-mode"
        class="btn btn-primary mat"
        type="button"
        @click="$EventBus.$emit('switchMode')"
      >
        <span class="fas fa-pencil"></span> &nbsp; Edit
      </button>

      <div :class="[isIM ? 'col-md-6 col-md-offset-3 im-container' : 'col-md-12']">
        <div :class="['row', isIM ? 'im-author' : null]">
          <div class="col-md-12">
            <div class="media">
              <div v-if="!isIM" class="media-left">
                <author-initial
                  class="media-object"
                  :authorName="character.nameTagKey"
                  :themeKey="character.FK_authorThemeKey"
                />
              </div>
              <div class="media-body">
                <h4 class="media-heading mt-5 mb-0">
                  {{ character.nameTagKey }}
                </h4>
                <h5>{{ character.title }}</h5>
              </div>
            </div>
          </div>
        </div>
        <div :class="['row', isIM ? 'mb-20' : null]">
          <div class="col-md-12">
            <div :class="[isIM ? '' : 'ml-60', 'mt-20']">
              <h4 class="mb-20">
                <strong>{{ question.subjectTagKey }}</strong>
              </h4>
              <div class="row mb-20" v-if="Object.keys(question.files).length">
                <div class="col-md-12">
                  <template v-for="file in question.files">
                    <mail-file :key="`file-${file.fileKey}`" class="mb-20" :file="file" />
                  </template>
                </div>
              </div>

              <div v-html="question.descriptionTagKey" />
            </div>
          </div>
        </div>
        <answer
          :question-type="question.FK_questionTypeKey"
          :display-type="question.FK_questionDisplayTypeKey"
          :answers="question.answers"
          class="answer-container"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import Answer from './Answer';
  import MailFile from './MailFile';
  import AuthorInitial from '@shared/AuthorInitial.vue';

  export default {
    props: ['question', 'character', 'showEdit'],

    components: {
      Answer,
      AuthorInitial,
      MailFile,
    },

    computed: {
      isIM() {
        return this.question.FK_questionDisplayTypeKey === 2;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @media print {
    .mail-container {
      page-break-after: always;
      margin-bottom: 0px;
    }
  }
  .mail-container {
    border-radius: 10px;
    background: white !important;
    border: 2px solid white !important;
  }

  #set-edit-mode {
    position: absolute;
    right: 15px;
    z-index: 999;
  }

  .im-container {
    padding: 0px 15px 15px;
    margin-top: 20px;
    border-radius: 5px;
    border: 2px solid black;

    .im-author {
      background: black !important;
      padding-top: 15px;
      padding-bottom: 15px;
      ::v-deep .media-body * {
        color: white !important;
      }
    }
  }
</style>
